// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__qekFh","header":"MessagesList_header__3DNTj","chat":"MessagesList_chat__2klJa"};